import React from "react";
import { Button, Box, Grid, Typography, Tab, Autocomplete, TextField } from "@mui/material";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";
import BookingReportStatus from "./BookingReportStatus";
import DateTab from "pages/date/Date";
import CommonFilter from "components/commonFilter/CommonFilter";

export default function CustomerReportTab(props) {
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };

  const handleChangePage = (event, newPage) => {
    props?.handleChangePage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const onClickTableVendor = (data) => {
    props?.onClickTableVendor(data);
  };

  const handleAuto = (e, value) => {
    props?.onInputChange(e, value)
  }

  const onExport = () => {
    props?.onExport()
  }

  const breadcrumbPaths = [
    { name: props?.title, url: "", className: "colorBlue" },
  ];

  return (
    <Grid container>
      <CommonBreadCrumb paths={breadcrumbPaths} />

      <Grid item className="tableContainer marginTop15" xs={12}>
        <Box className="contentBoxStyle">
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                item
                container
                md={12}
                spacing={4}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item >
                  <div>
                  <DateTab onSelectDateRange={props?.onSelectDateRange} tabName={props?.tabName} dateFrom={props?.dateFrom} dateTo={props?.dateTo}/>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="vendotTable">
              <BookingReportStatus
                titleData={props?.titleData}
                bookingData={props.bookingData}
                loaderBooking={props?.loaderBooking}
                isLoadingRideAnalytic={props?.isLoadingRideAnalytic}
                rideAnalytic={props?.rideAnalytic}
                countSrc={props?.countSrc}
              />

              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid item container justifyContent='space-between' alignItems='center' className="transictionHeader">
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title+' Reports'}
                    </Typography>
                    <Button className="exportBtnStyle" onClick={() => onExport()}>
                      Send Report to mail
                    </Button>

                  </Grid>
                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
